import { render, staticRenderFns } from "./OrderManagelist.vue?vue&type=template&id=b795789a&scoped=true&"
import script from "./OrderManagelist.vue?vue&type=script&lang=js&"
export * from "./OrderManagelist.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagelist.vue?vue&type=style&index=0&id=b795789a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b795789a",
  null
  
)

export default component.exports